import { PromoCodeCreatedBy, PromoCodeTag } from '../../../../../../services/exports/Constants';

export default {
  title: 'Kampagnekoder',
  tabs: {
    active: 'Aktiv',
    expired: 'Udløbet',
    email_sign_up: 'Kampagnekode ved e-mailtilmelding',
  },
  show_master_promo_code: 'Vis hovedkampagnekode til kunder',
  send_rejected_order_apologies_promo_code: 'Send kampagnekode til kunder, når en ordre afvises manuelt',
  filters: {
    tag: {
      placeholder: 'Tag',
      options: {
        [PromoCodeTag.Master]: 'Hoved',
        [PromoCodeTag.Campaign]: 'Kampagne',
        [PromoCodeTag.OneTime]: 'Engangs',
      },
    },
    code: {
      placeholder: 'Kode',
    },
    campaign: {
      placeholder: 'Kampagne',
    },
    created_by: {
      placeholder: 'Oprettet af',
      options: {
        [PromoCodeCreatedBy.User]: 'Bruger',
        [PromoCodeCreatedBy.System]: 'System',
      },
    },
  },
  fields: {
    code: 'Kode',
    tag: 'Tag',
    type: 'Type',
    discount_type: 'Rabattype',
    discount: 'Rabat',
    usage_threshold: 'Brugsgrænse',
    quantity: 'Antal',
    expires_at: 'Udløber',
    level: 'Niveau',
    max_discount: 'Maks. rabat',
    created_by: 'Oprettet af',
    image: 'Billede',
  },
  tags: {
    [PromoCodeTag.Master]: 'Hoved',
    [PromoCodeTag.Campaign]: 'Kampagne',
    [PromoCodeTag.OneTime]: 'Engangs',
  },
  types: {
    single_use: 'Enkeltbrug',
    multi_use: 'Flergangsbrug',
    unknown: 'Ukendt',
  },
  discount_types: {
    fixed_amount: 'Fast beløb',
    percentage: 'Procent',
    unknown: 'Ukendt',
  },
  created_by: {
    [PromoCodeCreatedBy.User]: 'Bruger',
    [PromoCodeCreatedBy.System]: 'System',
  },
  labels: {
    discount: 'Rabat',
    usage_threshold: 'Brugsgrænse',
    company: 'Virksomhed',
    restaurant: 'Restaurant',
    restaurant_group: 'Brand',
  },
  buttons: {
    add: 'Tilføj',
    edit: 'Rediger',
    delete: 'Slet',
    restore: 'Gendan',
    add_promo_code: 'Tilføj kampagnekode',
    images: 'Administrer billede',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
    failed_to_save_settings: 'Ændringerne kunne ikke gemmes',
    failed_to_delete_promo_code: 'Kampagnekoden kunne ikke slettes',
    failed_to_restore_promo_code: 'Kampagnekoden kunne ikke gendannes',
    promo_code_got_deleted: 'Kampagnekoden blev slettet',
    promo_code_got_restored: 'Kampagnekoden blev gendannet',
  },
  delete_confirmation: {
    title: 'Slet kampagnekode?',
    buttons: {
      yes: 'Ja',
      no: 'Nej',
    },
  },
  restore_confirmation: {
    title: 'Gendan kampagnekode?',
    buttons: {
      yes: 'Ja',
      no: 'Nej',
    },
  },
};
